import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = ["id", "rows", "maxlength", "value", "placeholder", "disabled", "aria-describedby"]
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-right text-xs text-catering-ink-500 font-catering-mono tabular-nums"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 3,
  class: "mt-2 text-sm text-red-500"
}

import { ulid } from 'ulid'
import { computed, ref } from 'vue'

export default {
  __name: 'InputArea',
  props: {
  modelValue: String,
  name: String,
  description: String,
  // Helper text under the label instead of under the textarea.
  descriptionAbove: { type: Boolean, default: false },
  placeholder: String,
  validateProfanity: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  rows: { type: [Number, String], default: 4 },
  maxlength: { type: [Number, String], default: null },
  counter: { type: Boolean, default: true },
  id: { type: String, default: null }
},
  emits: ['update:modelValue', 'validationResponse'],
  setup(__props, { emit: __emit }) {

const fallbackId = ulid()
const errorMessage = ref('')

const handleInput = (emission, value) => {
  if (props.disabled) return
  const forbiddenWords = findForbiddenWords(value)
  if (props.validateProfanity) {
    if (forbiddenWords.length === 1) {
      errorMessage.value = `We've detected a banned word in the message above. Please remove the word ${forbiddenWords[0]} to continue.`
      emit('validationResponse', false)
    } else if (forbiddenWords.length > 1) {
      errorMessage.value = `We've detected banned words in the message above. Please remove the following words to continue:  ${forbiddenWords.join(', ')}.`
      emit('validationResponse', false)
    } else {
      emit('validationResponse', true)
      errorMessage.value = null
    }
  }

  emit('update:modelValue', value)
}

const findForbiddenWords = value => {
  const forbiddenWords = [
    'get-rich-quick',
    'pyramid scheme',
    'MLM',
    'betting',
    'casino',
    'poker',
    'win big',
    'adult services',
    'escort',
    'porn',
    'CBD',
    'cannabis',
    'weed',
    'marijuana',
    'opioid',
    'THC',
    'quick loan',
    'debt relief',
    'credit repair',
    "you've won",
    'free money',
    'prescription drugs',
    'pharmacy without a prescription',
    'unclaimed prize',
    'limited time offer',
    'risk-free',
    'investment opportunity',
    'make money fast',
    'guaranteed income',
    'lottery',
    'prize claim',
    'double your money',
    'instant approval',
    'no credit check',
    'viagra',
    'levitra',
    'xanax',
    'tramadol',
    'opioids',
    'fentanyl',
    'heroin',
    'meth',
    'ecstasy',
    'cocaine',
    'steroids',
    'escort service',
    'sex',
    'nude',
    'scam',
    'fraud',
    'spam',
    'counterfeit',
    'bribe',
    'extortion',
    'blackmail',
    'terrorism',
    'bomb',
    'weapon',
    'gun',
    'firearm',
    'ammunition',
    'explosive',
    'murder',
    'kill',
    'suicide',
    'self-harm',
    'rape',
    'racist',
    'hate speech',
    'nazi',
    'swastika',
    'assassination',
    'fuck',
    'shit',
    'bitch',
    'asshole',
    'bastard',
    'cunt',
    'dick',
    'pussy',
    'cock',
    'slut',
    'whore',
    'faggot',
    'nigger',
    'kike',
    'chink',
    'spic'
  ]

  const foundWords = forbiddenWords.filter(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'i')
    return regex.test(value)
  })

  return foundWords.map(word => {
    return `"${word}"`
  })
}

const props = __props

const emit = __emit

const id = computed(() => props.id ?? fallbackId)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.disabled && 'opacity-50 cursor-not-allowed')
  }, [
    (props.name)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: id.value,
          class: _normalizeClass(["block text-sm font-medium text-gray-700 mb-1", props.disabled && 'cursor-not-allowed'])
        }, _toDisplayString(props.name), 11, _hoisted_1))
      : _createCommentVNode("", true),
    (props.description && props.descriptionAbove)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          id: id.value + '-description',
          class: "mb-2 text-sm text-gray-500"
        }, _toDisplayString(props.description), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("textarea", {
        id: id.value,
        rows: props.rows,
        maxlength: props.maxlength,
        class: _normalizeClass(["block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-500 focus:ring-brand-500 sm:text-sm placeholder:text-gray-500", props.disabled && 'bg-gray-50 text-gray-500 cursor-not-allowed']),
        value: props.modelValue,
        placeholder: props.placeholder,
        disabled: props.disabled,
        "aria-describedby": id.value + '-description',
        onInput: _cache[0] || (_cache[0] = e => handleInput('update:modelValue', e.target.value))
      }, null, 42, _hoisted_4),
      (props.maxlength && props.counter)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString((props.modelValue || '').length) + " / " + _toDisplayString(props.maxlength), 1))
        : _createCommentVNode("", true)
    ]),
    (props.description && !props.descriptionAbove)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          id: id.value + '-description',
          class: "mt-2 text-sm text-gray-500"
        }, _toDisplayString(props.description), 9, _hoisted_6))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

}